import React, { createContext, useRef, useContext } from "react"
import { useFrame, useThree } from "@react-three/fiber"
import lerp from "lerp"
import useContentStore from "./redux/stores/contentStore"

const offsetContext = createContext(0)

function Block({ children, offset, factor, ...props }) {
  const content = useContentStore((state) => state.content)
  const { offset: parentOffset, sectionHeight } = useBlock()
  const ref = useRef()
  offset = offset !== undefined ? offset : parentOffset
  useFrame(() => {
      if (!ref.current)
          return;
      const curY = ref.current.position.y
      const curTop = content.top.current
      ref.current.position.y = lerp(curY, (curTop / content.zoom) * factor, 0.1)
  })
  return (
    <offsetContext.Provider value={offset}>
      <group {...props} position={[0, -sectionHeight * offset * factor, 0]}>
        <group ref={ref}>{children}</group>
      </group>
    </offsetContext.Provider>
  )
}

function useBlock() {
  const { sections, pages, zoom } = useContentStore((state) => state.content)
  const { size, viewport } = useThree()
  const offset = useContext(offsetContext)
  const viewportWidth = viewport.width * zoom
  const viewportHeight = viewport.height * zoom
  const canvasWidth = viewportWidth / zoom
  const canvasHeight = viewportHeight / zoom
  const mobile = size.width < 700
  const margin = canvasWidth * (mobile ? 0.2 : 0.1)
  const contentMaxWidth = canvasWidth * (mobile ? 0.8 : 0.6)
  // const sectionHeight = canvasHeight * ((pages - 1) / (sections - 1))
  const sectionHeight = canvasHeight
  const offsetFactor = (offset + 1.0) / sections
  return {
    viewport,
    offset,
    viewportWidth,
    viewportHeight,
    canvasWidth,
    canvasHeight,
    mobile,
    margin,
    contentMaxWidth,
    sectionHeight,
    offsetFactor
  }
}

export { Block, useBlock }
